module.exports = __webpack_public_path__ + "static/media/televisao.419146c2.png";